import React, { useState } from "react";
import "./newexpencesform.css";

function Newexpencesform(props) {
  let [title, settitle] = useState("");
  let [amount, setamount] = useState("");
  let [date, setdate] = useState("");

  let titlechage = (e) => {
    settitle(e.target.value);
  };
  let amountchage = (e) => {
    setamount(e.target.value);
  };
  let datechage = (e) => {
    setdate(e.target.value);
  };

  let expencesubmit = (e) => {
    e.preventDefault();
    let expncedata = {
      title: title,
      amount: amount,
      date: new Date(date),
    };
    props.saveData(expncedata);
    settitle('')
    setamount('');
    setdate('');
   
  };
  return (
    <div>
      <form action="" onSubmit={expencesubmit} class="form">
        <div className="main">
          <div className="input-all">
            <input
              type="text"
              placeholder="Title"
              class="form__input"
              id="title"
              onChange={titlechage}
              value={title}
            />
            <input
              type="number"
              placeholder="Amount"
              class="form__input"
              id="amount"
              onChange={amountchage}
              value={amount}
            />
            <input
              type="date"
              placeholder="Date"
              class="form__input"
              id="date"
              onChange={datechage}
              value={date}
            />
          </div>
          <div className="add-btn">
            <button type="submit" className="button-28">
              Add Expence
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Newexpencesform;
